<template>
    <div id="app">
        <BannerNav ref="navBarRef" />
        <router-view @change="checkLogin" @checkLogin="checkLogin" ></router-view>
        <FooterArea :clarityIdProps="clarityId" />
    </div>
</template>

<script setup>
// @ is an alias to /src
        import BannerNav from "@/components/banner.vue";
        import FooterArea from "@/components/footer.vue";
        import Swal from "sweetalert2";
        import {onBeforeUnmount, onMounted, onUpdated, ref, inject } from "vue";
        import userStatus from "@/utils/userStatus";
        import _ from "lodash";
        import {useRouter} from "vue-router";
        import { v4 as uuidv4 } from 'uuid';
        import { postApi } from "@/utils/callApi";
        import apiConfig from "@/utils/apiConfig";

        const router = useRouter();//轉跳router
        const $cookies = inject('$cookies');
        const eventList = ["scroll", "click", "mousemove"
            , "keyup", "keypress", "touchstart"
            , "touchend", "touchcancel", "touchmove"];
        const clarityId = ref('');
        const alertFunc = (errorTxt, errorTitle, icon, thenCallback) =>{ //錯誤alert
            Swal.fire({
                title: errorTitle,
                confirmButtonText: "確定",
                html: '<img src="'+ icon +'.svg"><p>'+ errorTxt + '</p>'
            }).then(thenCallback);
        };

        const uuid = () =>{
            let uuid = sessionStorage.getItem('sessionId');
            if (!uuid) {
                sessionStorage.setItem('sessionId', uuidv4());
            }
        }
        // const isSendClarity = () => {
        //     let isSendClarity = sessionStorage.getItem('isSendClarity');
        //     if (!isSendClarity) {
        //         sessionStorage.setItem('isSendClarity', false);
        //     }
        // }

        const sendClarity= _.throttle( () => {
            clarityId.value = $cookies.get('_clck').split('^')[0]
            let isSendClarity = JSON.parse(sessionStorage.getItem('isSendClarity'));
            let sessionId = sessionStorage.getItem('sessionId');
            // console.log('init sendClarity', window.fpc, window.clarity, isSendClarity, $cookies.keys());
            // console.log('init sendClarity', $cookies.keys());
            // console.log('clarityID', $cookies.get('_clck').split('|')[0]);
            if(window.fpc && window.clarity && sessionId && !isSendClarity){
                // console.log('sendClarity', window.fpc,route.name, sessionStorage.getItem('sessionId'));
                // let r  = window.clarity("identify", window.fpc, sessionStorage.getItem('sessionId'),route.name);
                // console.log(r);
                sessionStorage.setItem('isSendClarity', true);
                sessionStorage.setItem('fpcInfo', JSON.stringify({
                    clarityId: clarityId.value,
                    sessionId: sessionId,
                    fpc: window.fpc
                }));
                utmSource();
            }
        }, 1000 * 3)


        const refreshToken = _.throttle(() =>{
            let jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));
            if (jwtInfo) {
                if(process.env.VUE_APP_ENV === 'dev'){
                    userStatus.refreshTokenForDev({
                        account: jwtInfo.account,
                        token: jwtInfo.refreshToken
                    }, function (jwtInfo) {
                        if (!jwtInfo) {
                            alertFunc('您好，因網頁閒置已逾30分鐘，未進行任何操作，基於資訊安全的考量，請按下確認後回到首頁，謝謝！', '逾期使用', 'error', ()=>{
                                checkLogin();
                                router.push('/');
                            })
                        }
                    });
                }else{
                    userStatus.refreshToken(jwtInfo.appKey, function (jwtInfo) {
                        if (!jwtInfo) {
                            alertFunc('您好，因網頁閒置已逾30分鐘，未進行任何操作，基於資訊安全的考量，請按下確認後回到首頁，謝謝！', '逾期使用', 'error', ()=>{
                                checkLogin();
                                router.push('/');
                            })
                        }
                    });
                }
            }
        },1000 * 60 * 5)

        const logout = _.debounce(() =>{
            let jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));
            if (jwtInfo) {
                // TODO: 開發時使用 上線需調整
                userStatus.logout(jwtInfo.appKey, function () {
                    alertFunc('您好，因網頁閒置已逾30分鐘，未進行任何操作，基於資訊安全的考量，請按下確認後回到首頁，謝謝！', '逾期使用', 'error', ()=>{
                        checkLogin();
                        router.push('/');
                    })
                });
            }
        },1000 * 60 * 25)

        const navBarRef = ref();
        const checkLogin = () =>{
            navBarRef.value?.reLoadJwt();
        }
        // const sweetAlertClarity=()=>{
        //     document.querySelector('.swal2-html-container p').classList.add('clarity-mask');
        // }

        // RND-172 訂單來源媒介 2025.01.10 HansHuang
        const utmSource = () =>{            
            /* 
            使用 regex 判斷字串含有 "utm_source=[any]&utm_medium=[any]" 存入 sessionStorage
            存入前，先判斷 sessionStorage 是否已存在，
            若存在則進行內容比對，若不同則更新
            若不存在則直接存入
            */
            let queryString = window.location.search;
            const regex = /utm_source=[^&]+&utm_medium=[^&]+|gclid=[^&]+/g;
            let matches = queryString.match(regex);
            if (matches) {
                const existingUtmParams = JSON.parse(sessionStorage.getItem('utmParams'));
                console.log(existingUtmParams, matches, arraysEqualIgnoreOrder(existingUtmParams, matches))
                if (!arraysEqualIgnoreOrder(existingUtmParams, matches)) {
                    sessionStorage.setItem('utmParams', JSON.stringify(matches));
                    matches.forEach(newUtmParams => {
                        // 若 newUtmParams 開頭是 gclid 送至 clarity api 的 tagName 為 gclid，反之則為 UTM
                        let tagName, tagValue;
                        if (newUtmParams.startsWith('gclid')) {
                            tagName = 'gclid';
                            tagValue = '';
                        } else {
                            tagName = 'UTM';
                            tagValue = newUtmParams;
                        }
                        let fpcInfo = JSON.parse(sessionStorage.getItem('fpcInfo'));
                        if(fpcInfo){
                            postApi(apiConfig.event, null, null, null, {
                                tagName: tagName,
                                tagValue: tagValue,
                                sessionId: fpcInfo.sessionId,
                                fpc: fpcInfo.fpc,
                                clarityId: fpcInfo.clarityId,
                                insuranceType: "旅平險",
                            });
                        }                    
                    });
                }
            }
        }

        const arraysEqualIgnoreOrder = (arr1, arr2) => {
            if (!Array.isArray(arr1) || !Array.isArray(arr2) || arr1.length !== arr2.length) {
                return false;
            }
            // 對陣列進行排序後再比較
            const sortedArr1 = arr1.slice().sort();
            const sortedArr2 = arr2.slice().sort();
            for (let i = 0; i < sortedArr1.length; i++) {
                if (sortedArr1[i] !== sortedArr2[i]) {
                    return false;
                }
            }
            return true;
        }

        uuid();

        onMounted(()=>{
            eventList.forEach(event => {
                document.addEventListener(event, refreshToken);
            });
            eventList.forEach(event => {
                document.addEventListener(event, logout);
            });
            eventList.forEach(event => {
                document.addEventListener(event, sendClarity);
            });
        });

        onBeforeUnmount(()=>{
            eventList.forEach(event => {
                document.removeEventListener(event, refreshToken);
            });
            eventList.forEach(event => {
                document.removeEventListener(event, logout);
            });
        });

        router.beforeEach((to, from, next) => {
            sessionStorage.setItem('isSendClarity', false);
            if (to.meta.requiresAuth) {
                const userData = JSON.parse(localStorage.getItem("jwtInfo"));
                if (userData) {
                    next();
                } else {
                    next({
                        path: '/'
                    })
                }
            } else {
                next();
            }

            if(to.meta.allowBack != null){
                if (!to.meta.allowBack) {
                    history.pushState(null, null, document.URL);
                    window.addEventListener('popstate', function () {
                        history.pushState(null, null, document.URL);
                    });
                }else{
                    next();
                }
            }
        });
</script>
<style lang="scss">
@import "./assets/style/layout.scss";
</style>
